import React from "react";
import { Col, Form, Input, Modal, Row, Space, theme } from "antd";
import { SUCCESS_COLOR } from "../../constants/color";
import { DELETE, PATCH, POST } from "../../frameworks/HttpClient";
import { URL_POND } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import _ from "lodash";
import { POND_STATUS } from "../../constants/string";
import ColorButton from "../../common/ColorButton";

export default function PondOpenLotModal(props) {
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages, setErrorMessages] = React.useState(null);
  const isCreate =  target ? target.state !== POND_STATUS.FILLING : false 
  const [form] = Form.useForm();
	const { token: { colorWarning, colorError }} = theme.useToken();

  const handleOK = async() => {
    setErrorMessages(null)
    try {
      // preapare data
      const data = await form.validateFields();

      // post open lot
      if(isCreate){
        data['pond'] = _.get(target, 'id' , '-')
        await POST(URL_POND.POND_TRANSACTION, data)
      } else {
        await PATCH(`${URL_POND.POND_TRANSACTION}${target.current_transaction}/`, data)
      }
      // close modal and update data
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const handleDelete = async() => {
    try {
      const data = await form.validateFields();
      await DELETE(`${URL_POND.POND_TRANSACTION}${target.current_transaction}/`)
      onUpdate();
    } catch (error) {
      setErrorMessages(error.ErrorMessages)
    }
  }

  React.useEffect(() => {
    if(open)
      setErrorMessages(null)
      if(isCreate){
        form.resetFields();
      } else {
        form.setFieldsValue(target)
      }
  },[open])

  return(
    <Modal
      open={open}
      onCancel={onClose}
      title={`บ่อ [${_.get(target, 'name' , '-')}]`}
      width={400}
      // okText={isCreate ? "ยืนยัน" : "แก้ไข"}
      cancelText={"ปิด"}
      okButtonProps={{ style: { backgroundColor : isCreate ? SUCCESS_COLOR : colorWarning}}}
      onOk={handleOK}
      footer={[
          !isCreate && (
            <ColorButton disabled={_.get(target, 'deletable', true) ? false : true} type={'primary'} style={{ float: "left" }} override={colorError} onClick={() => handleDelete()} >
              ลบล็อต
            </ColorButton>)
          ,
            <ColorButton onClick={onClose} >
              ปิด
            </ColorButton>
          ,
            <ColorButton type={'primary'} override={isCreate ? SUCCESS_COLOR : colorWarning} onClick={() => handleOK()}>
              {isCreate ? "ยืนยัน" : "แก้ไข"}
            </ColorButton>
      ]}
    >
      <ErrorMessages message={errorMessages}/>
      <Form form={form} >
        <Form.Item 
          name={'lot_no'}
          label={'เลข lot'}
          rules={[{ required: true, message: 'กรุณาหมายเลขล็อต!' }]}
        >
          <Input placeholder="หมายเลขล็อต" autoComplete="off"/>
        </Form.Item>
      </Form>
    </Modal>
  )
}